import styled from 'styled-components';

//components
import { Section } from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const OfficeSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const OfficeRow = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  text-align: center;

  ${screen.md} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    gap: 24px;
  }

  ${screen.lg} {
    gap: 48px;
  }
`;

export const OfficeCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  ${screen.md} {
    align-items: flex-start;
    flex-shrink: 0;
    width: 365px;
  }

  ${screen.xxlg} {
    width: 460px;
  }
`;

export const OfficeTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
  font-size: 38px;
  margin: 0;
  color: ${homeColor.white};

  ${screen.xxlg} {
    font-size: 48px;
  }
`;

export const OfficeAddress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 21px;
  line-height: 1.5;
  color: ${homeColor.white};

  span {
    font-family: ${getToken('font-family-title')};
    font-weight: 500;
    color: ${homeColor.muted};
  }

  ${screen.md} {
    font-size: 24px;
  }

  ${screen.xxlg} {
    font-size: 26px;
  }
`;

export const OfficeImage = styled.img`
  width: 100%;
  max-width: 292px;
  height: 260px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid ${homeColor.line};

  ${screen.lg} {
    max-width: 540px;
    height: 362px;
    border-radius: 14px;
  }

  ${screen.xxlg} {
    max-width: 613px;
    height: 440px;
    border-radius: 10px;
  }
`;
